// @ts-nocheck
/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.3
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-router-dom components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import MuiLink from "@mui/material/Link";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";

function DefaultBackgroundCard({
  color = "dark",
  image,
  title,
  description,
  badge = "",
  action = false,
  compact = false,
  overlay = true,
}) {
  const template = (
    <Card
      sx={({
        functions: { rgba, linearGradient },
        palette: { gradients },
        borders: { borderRadius },
      }) => ({
        backgroundImage: overlay
          ? gradients[color]
            ? `${linearGradient(
              rgba(gradients[color].main, 0.8),
              rgba(gradients[color].state, 0.8)
            )}, url(${image})`
            : `${linearGradient(
              rgba(gradients.dark.main, 0.8),
              rgba(gradients.dark.state, 0.8)
            )}, url(${image})`
          : `url(${image})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: borderRadius.lg,
        height: "100%",
      })}
    >
      <SoftBox
        textAlign={compact ? "left" : "center"}
        py={compact ? 8 : 20}
        px={3}
        lineHeight={1}
        display="flex"
        flexDirection="column"
        justifyContent={compact ? "flex-end" : "center"}
        minHeight={compact ? "320px" : "100%"}
      >
        <SoftTypography variant={compact ? "h4" : "h2"} fontWeight="bold" color="white" gutterBottom>
          {title}
        </SoftTypography>
        <SoftBox mb={3}>
          <SoftTypography variant="body2" color="white">
            {description}
          </SoftTypography>
        </SoftBox>
        {badge && (
          <SoftBox alignSelf={compact ? "flex-start" : "center"}>
            <SoftBadge variant="contained" color="light" badgeContent={badge} container />
          </SoftBox>
        )}
      </SoftBox>
    </Card>
  );

  return action.type === "external" ? (
    <MuiLink href={action.route} target="_blank" rel="noreferrer">
      {template}
    </MuiLink>
  ) : (
    <Link to={action.route}>{template}</Link>
  );
}

// Typechecking props for the DefaultBackgroundCard
DefaultBackgroundCard.propTypes = {
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  image: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.node.isRequired,
  badge: PropTypes.string,
  action: PropTypes.oneOfType([
    PropTypes.shape({
      type: PropTypes.oneOf(["external", "internal"]).isRequired,
      route: PropTypes.string.isRequired,
    }),
    PropTypes.bool,
  ]),
  compact: PropTypes.bool,
  overlay: PropTypes.bool,
};

export default DefaultBackgroundCard;
